import { render, staticRenderFns } from "./SidebarBrandSwitcher.vue?vue&type=template&id=e049fd26&scoped=true&"
import script from "./SidebarBrandSwitcher.vue?vue&type=script&lang=ts&"
export * from "./SidebarBrandSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarBrandSwitcher.vue?vue&type=style&index=0&id=e049fd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e049fd26",
  null
  
)

export default component.exports